export const MaxLength = {
	USER_NAME: 150,
	FULL_NAME: 256,
	EMAIL: 150,
	ADDRESS: 200,
	TELEPHONE: 50,
} as const;
